import * as yup from 'yup';

import { previousInsuranceSchema } from '@/features/Contract/Shared/contractBaseSchema';
import { containsNonAsciiLetters } from '@/utils/strings/strings';

export const kfzContractBaseSchema = yup.object({
  vorversicherungsDaten: previousInsuranceSchema,
  memofeldBeratungsdokumentation: yup
    .string()
    .default('')
    .test(
      'isValidMemofeld',
      'Das Feld darf nur ASCII Zeichen enthalten.',
      (value) => !containsNonAsciiLetters(value),
    ),
});

export type KfzContractBase = yup.Asserts<typeof kfzContractBaseSchema>;
